//icons grid dashboard
import analyzedAutoresponderIcon from 'img/AnalyzedAutoresponderIcon.svg';
import autoresponderColoredIcon from 'img/AutoresponderIcon.svg';
import closedEnvelopeImg from "img/closed-envelope-subtitle.svg";
import openedEnvelopeImg from "img/opened-envelope-subtitle.svg";
import analyzedOLIcon from 'img/AnalyzedOLIcon.svg';
import oLColoredIcon from 'img/OLIcon.svg';

//icon grid Order dashboard
import orangeCircleIcon from "img/orange-circle-icon.svg";
import historyDownloadOrderIcon from 'img/history-download-order.svg';
import orderMirrorDownloadIcon from 'img/order-mirror-download-icon.svg';

//icons create MapProduct
import editBtn from 'img/edit-icon-table.svg';
import priceHistoryBtn from "img/icon-price-history.svg";
import downloadTechnicalSheetBtn from "img/download-technical-sheet.svg";
import itemValidity from "img/item-validity.svg";
import RedStockIcon from 'img/redStockIcon.svg';
import BlueStockIcon from 'img/stockIcon.svg';

//icons OrderDetails
import ViveoIcon from 'img/viveo-icon.svg';
import ClientIcon from 'img/client-icon.svg';
import DcIdealBilling from "img/DcIdealBilling.svg";
import AutomaticPriorityIcon from "img/automatic-priority-icon.svg";

//icons Details
import OlIcon from "img/OLIconViveo.svg";

export const subtitlesDashboard = [
  {
    img: closedEnvelopeImg,
    label: "Não lida"
  },
  {
    img: openedEnvelopeImg,
    label: "Lida"
  },
  {
    img: autoresponderColoredIcon,
    label: "Resp. automática não lida"
  },
  {
    img: analyzedAutoresponderIcon,
    label: "Resp. automática lida"
  },
  {
    img: oLColoredIcon,
    label: "Itens de OL não lida"
  },
  {
    img: analyzedOLIcon,
    label: "Itens de OL lida"
  }
];

export const subtitlesOrderDashboard = [
  {
    img: orangeCircleIcon,
    label: "Novo pedido resgatado"
  },
  {
    img: orderMirrorDownloadIcon,
    label: "Baixar espelho do pedido"
  },
  {
    img: historyDownloadOrderIcon,
    label: "Histórico de downloads"
  },
];

export const subtitlesCreateMapProduct = [
  {
    img: BlueStockIcon,
    label: "Estoque"
  },
  {
    img: RedStockIcon,
    label: "Estoque zerado"
  },
  {
    img: priceHistoryBtn,
    label: "Histórico de preço"
  },
  {
    img: itemValidity,
    label: "Validade próxima"
  },
  {
    img: downloadTechnicalSheetBtn,
    label: "Ficha técnica"
  },
  {
    img: editBtn,
    label: "Editar"
  },
];

export const subtitlesOrderDetails = [
  {
    img: ClientIcon,
    label: "Cliente"
  },
  {
    img: ViveoIcon,
    label: "Viveo"
  },
  {
    img: DcIdealBilling,
    label: "CD prioritário"
  },
  {
    img: BlueStockIcon,
    label: "Estoque"
  },
  {
    img: priceHistoryBtn,
    label: "Histórico de preços"
  },
  {
    img: AutomaticPriorityIcon,
    label: "Prioridade automática"
  },
  {
    img: itemValidity,
    label: "Validade"
  },
];

export const subtitlesQuoteDetails = [
  {
    img: ClientIcon,
    label: "Cliente"
  },
  {
    img: ViveoIcon,
    label: "Viveo"
  },
  {
    img: OlIcon,
    label: "Itens de OL"
  },
  {
    img: DcIdealBilling,
    label: "CD prioritário"
  },
  {
    img: BlueStockIcon,
    label: "Estoque"
  },
  {
    img: RedStockIcon,
    label: "Estoque zerado"
  },
  {
    img: priceHistoryBtn,
    label: "Histórico de preço"
  },
  {
    img: downloadTechnicalSheetBtn,
    label: "Ficha técnica"
  },
  {
    img: editBtn,
    label: "Editar"
  },
  {
    img: itemValidity,
    label: "Validade próxima"
  },
]
